// import { CTableRow } from '@coreui/react'
// import { CChartLine } from '@coreui/react-chartjs'
// import { getStyle, hexToRgba } from '@coreui/utils'
import { CButton, CCol, CModal, CModalBody, CRow, CSpinner } from '@coreui/react'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MyRoutes } from 'src/routes'
import { post } from 'src/services/http-service'
import { ENDPOINT_POST_CREATE_ITINERARY } from 'src/variables'
import { ItineraryFormCreate } from 'src/components/forms/create/itineraryFormCreate'
import { GameFields } from 'src/components/forms/gameFields'

const AddItinerary = () => {
  // const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)
  const userToken = useSelector((state) => state.user.token)
  const userEmail = useSelector((state) => state.user.email)
  const [itinerary, setItinerary] = useState()
  const [createRequestState, setCreateRequestState] = useState('not_sent')

  const navigate = useNavigate()

  // useEffect(() => {
  //   async function sendItineraryCreateRequest(body) {
  //     console.log(body)
  //     const res = await post({
  //       endpoint: ENDPOINT_POST_CREATE_ITINERARY,
  //       bearerToken: userToken,
  //       data: body,
  //     })

  //     console.log(res)
  //   }

  //   if (itinerary) {
  //     const reqBody = formOutput2CreateBody(itinerary)
  //     sendItineraryCreateRequest(reqBody)
  //   }
  // }, [itinerary])

  async function submit() {
    const reqBody = formOutput2CreateBody(itinerary)
    reqBody.partner_email = userEmail
    console.log(reqBody)
    setCreateRequestState('pending')

    try {
      const res = await post({
        endpoint: ENDPOINT_POST_CREATE_ITINERARY,
        bearerToken: userToken,
        data: reqBody,
      })
      // console.log('res: ', res)
      setCreateRequestState('success')
    } catch (err) {
      // console.log('err: ', err)
      setCreateRequestState('failure')
    }
  }

  function gameConfiguration2Record(configuration, gameType) {
    const { title, description, hint, locale, isDefault, ...config } = configuration

    return {
      title,
      description,
      hint,
      config: JSON.stringify(
        GameFields[gameType].reduce(
          (acc, field) => ({
            ...acc,
            [field.name]: field.name === 'reward' ? Number(config[field.name]) : config[field.name],
          }),
          {},
        ),
      ),
      locale,
      isDefault,
    }
  }

  function formOutput2CreateBody(itinerary) {
    // strip non valid id from itinerary body
    const { id, ...rest } = itinerary
    let createBody = rest
    // get tags id and strip the label
    createBody.tags = createBody.tags.map((tag) => tag.value)
    createBody.waypoints = createBody.waypoints.map((waypoint) => {
      // strip non valid id from waypoint body
      const { waypointId: id, ...waypointRest } = waypoint
      let waypointBody = waypointRest
      waypointBody.games = waypointBody.games.map((game) => {
        // strip non valid id from game body
        const { gameId: id, ...gameRest } = game
        gameRest.locales = gameRest.locales.map((locale) =>
          gameConfiguration2Record(locale, gameRest.type),
        )
        return gameRest
      })
      return waypointRest
    })

    createBody = {
      ...createBody,
      locales: JSON.stringify(createBody.locales),
      waypoints: JSON.stringify(createBody.waypoints),
    }

    return createBody
  }

  return (
    <>
      <ItineraryFormCreate onChange={setItinerary} onSubmit={submit}></ItineraryFormCreate>
      <CModal
        alignment="center"
        className="show position-fixed"
        keyboard={false}
        portal={false}
        visible={createRequestState !== 'not_sent'}
      >
        <CModalBody>
          <CRow className="justify-content-center align-items-center">
            <CCol className="text-center">
              {createRequestState === 'pending' ? (
                <CSpinner />
              ) : createRequestState === 'success' ? (
                <>
                  <p>Itinerario creato con successo!</p>
                  <CButton color="primary" onClick={() => navigate(MyRoutes.DASHBOARD)}>
                    Vai alla dashboard
                  </CButton>
                </>
              ) : (
                <>
                  <p>{`Non é stato possibile creare l'itinerario`}</p>
                  <CButton color="primary" onClick={() => navigate(MyRoutes.DASHBOARD)}>
                    Vai alla dashboard
                  </CButton>
                </>
              )}
            </CCol>
          </CRow>
        </CModalBody>
      </CModal>
    </>
  )
}

export default AddItinerary
